import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { useCookies } from 'react-cookie';
import type {
  ApplicationUserAttribute,
  SingleApplicationUserResponse,
} from 'types/ApplicationUser';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

type MutationVariables = Partial<ApplicationUserAttribute>;

const RegisterUser = (registrationAttributes: MutationVariables) => {
  const body = {
    data: {
      type: SPARK_RESOURCE_TYPES.APPLICATION_USERS,
      attributes: {
        name: registrationAttributes.name,
        email: registrationAttributes.email,
        password: registrationAttributes.password,
        surname: registrationAttributes.surname,
        ...(!!registrationAttributes.referralCode && {
          referralCode: registrationAttributes.referralCode,
        }),
        ...(!!registrationAttributes.subscriptionCreditOptionID && {
          subscriptionCreditOptionID:
            registrationAttributes.subscriptionCreditOptionID,
        }),
      },
    },
  };
  const url = generateURL(SPARK_RESOURCE_TYPES.APPLICATION_USERS);
  const token = process.env.REACT_APP_RESTRICTED_ADMIN_TOKEN;
  return fetchWrapper<SingleApplicationUserResponse>({
    url: url,
    method: 'POST',
    body: body,
    token,
  });
};

export function useRegisterUser() {
  const cookie = useCookies();
  const setCookie = cookie[1];
  return useMutation('userRegister', RegisterUser, {
    onSuccess: (data) => {
      if (data.data.attributes.token) {
        setCookie('userToken', data.data.attributes.token, { path: '/' });
        setCookie('userID', data.data.id, { path: '/' });
        //@ts-ignore
        window.analytics.identify(data.data.user);
      }
      if (data.data.attributes.stripeCheckoutURL) {
        const stripeCheckoutURL = data.data.attributes.stripeCheckoutURL;
        window.open(stripeCheckoutURL, '_self');
      }
    },

    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Registration Failed : ${error.message}`);
      }
    },
  });
}
